import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';
import { TYPES } from './index.constants';

const {
    StyledContainer,
    StyledContent,
    StyledHeaderContainer,
    StyledHeader,
    StyledIcon,
    StyledIconContainer,
    StyledArrowContainer,
    StyledArrowMsg,
} = Styles;

export const ContentDropdown = ({
    id,
    closedHeader,
    openHeader,
    defaultCollapsed,
    closedArrowText,
    openArrowText,
    arrowWidth,
    children,
    type,
    buttonDisabled,
    ...otherProps
}) => {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);

    useEffect(() => {
        if (buttonDisabled) {
            setCollapsed(true);
        }
    }, [buttonDisabled]);

    return (
        <StyledContainer id={id} collapsed={collapsed} type={type} {...otherProps}>
            <StyledHeaderContainer>
                <StyledHeader type={type}>{collapsed ? closedHeader : openHeader}</StyledHeader>
                <StyledArrowContainer
                    arrowWidth={arrowWidth}
                    type={type}
                    hasBorder={closedArrowText && openArrowText}
                    disabled={buttonDisabled}
                    onClick={() => !buttonDisabled && setCollapsed(prev => !prev)}
                >
                    {closedArrowText && collapsed && (
                        <StyledArrowMsg>{closedArrowText}</StyledArrowMsg>
                    )}
                    {openArrowText && !collapsed && (
                        <StyledArrowMsg>{openArrowText}</StyledArrowMsg>
                    )}
                    {!buttonDisabled && (
                        <StyledIconContainer collapsed={collapsed}>
                            <StyledIcon padLeft icon={['fas', 'chevron-right']} />
                        </StyledIconContainer>
                    )}
                </StyledArrowContainer>
            </StyledHeaderContainer>
            <StyledContent collapsed={collapsed} type={type}>
                {children}
            </StyledContent>
        </StyledContainer>
    );
};

ContentDropdown.propTypes = {
    id: PropTypes.string,
    closedHeader: PropTypes.node,
    openHeader: PropTypes.node,
    defaultCollapsed: PropTypes.bool,
    closedArrowText: PropTypes.string,
    openArrowText: PropTypes.string,
    children: PropTypes.node,
    light: PropTypes.bool,
    shadow: PropTypes.bool,
    width: PropTypes.string,
    arrowWidth: PropTypes.string,
    type: PropTypes.string,
    buttonDisabled: PropTypes.bool,
    maxHeightCollapsed: PropTypes.string,
};

ContentDropdown.defaultProps = {
    id: '',
    closedHeader: '',
    openHeader: '',
    defaultCollapsed: true,
    closedArrowText: '',
    openArrowText: '',
    children: '',
    light: false,
    shadow: false,
    width: '100%',
    arrowWidth: '',
    type: TYPES.WIDER,
    buttonDisabled: false,
    maxHeightCollapsed: '',
};

ContentDropdown.Styles = Styles;
